import PasswordUpdate from './PasswordUpdate';

export default PasswordUpdate;